__turbopack_context__.v({
  "switchCont": "index-module-scss-module__cbNZIa__switchCont",
});
